// extracted by mini-css-extract-plugin
export default {"borderWarning":"styles_borderWarning__o6fWI","borderError":"styles_borderError__nN0Ot","borderSuccess":"styles_borderSuccess__gGlb+"};